export default {
  appointment: '/showing/appointment/:appointmentId',
  feedback: '/showing/appointment/:appointmentId/feedback',
  showing: '/showing/:Id',
  externalDelegates: '/appointment/approval/:uuid',
};
